import React, { useState, useEffect } from 'react';
import { Download, ChevronLeft, ChevronRight } from 'lucide-react';
import { Container } from "react-bootstrap";
import "./HighlightsCrousel.css"


const GridCarousel = () => {
  const [images, setImages] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  const jsonPath = process.env.REACT_APP_CDN_CAROUSEL + "postevents/ussaic2025/ussaic2025Images.json?t=" + Date.now()
   const downloadImg = process.env.REACT_APP_CDN_LINK + "ussaic/download-icon.webp"


  // Fetch images from JSON endpoint
  useEffect(() => {
    const fetchImages = async () => {
      try {
        setLoading(true);
        const response = await fetch(jsonPath);
       
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
       
        const data = await response.json();
       
        // Transform the data to match our component structure
        const transformedImages = data.map(item => ({
          id: item.id,
          url: item.imgPath,
          alt: `Event Image ${item.id}`
        }));
       
        setImages(transformedImages);
        setError(null);
      } catch (err) {

        setError('Failed to load images. Please try again later.');
      } finally {
        setLoading(false);
      }
    };


    fetchImages();
  }, []);
 
  let imagesPerSlide = 12;
  if (window.innerWidth < 768) {
    imagesPerSlide = 8;
  }
  const totalSlides = Math.ceil(images.length / imagesPerSlide);


  // Auto-scroll functionality
  useEffect(() => {
    if (!isPaused && !loading && images.length > 0) {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % totalSlides);
      }, 20000); // Auto-scroll every 4 seconds


      return () => clearInterval(interval);
    }
  }, [isPaused, totalSlides, loading, images.length]);


  // Get current slide images
  const getCurrentSlideImages = () => {
    const startIndex = currentSlide * imagesPerSlide;
    return images.slice(startIndex, startIndex + imagesPerSlide);
  };
  const scrollToTop = () => {
    const gridContainer = document.getElementById('grid-container');
    if (gridContainer) {
      const elementTop = gridContainer.offsetTop;
      const offsetPosition = elementTop - 80;
     
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };


  // Download image function
  const downloadImage = async (imageUrl, imageName) => {
    try {
      const response = await fetch(imageUrl, {
        mode: 'cors',
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
      });
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `event_image_${imageName}.webp`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {

      // Fallback: open image in new tab
      window.open(imageUrl, '_blank');
    }
  };


  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
    scrollToTop();
  };


  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
    scrollToTop();
  };


 
  // Define grid sizes for variety
  const getGridItemClass = (index) => {
    const patterns = [
      // 'grid-item-large',
      'grid-item-medium',
      'grid-item-small',
      'grid-item-medium',
      'grid-item-small',
      'grid-item-small',
      'grid-item-medium',
      'grid-item-small',
      'grid-item-medium',
      // 'grid-item-large',
      'grid-item-small',
      'grid-item-medium',
      'grid-item-small',
      'grid-item-medium',
      'grid-item-large',
      // 'grid-item-small'
    ];
    return patterns[index % patterns.length];
  };


  return (
    <div className="carousel-container" id="grid-container">
       <div className="event-memories-div">
            <p className="event-memories-div-text">Event Memories</p>
         </div>
      <Container>

      {loading && (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading images...</p>
        </div>
      )}


      {error && (
        <div className="error-container">
          <p className="error-message">{error}</p>
          <button
            className="retry-btn"
            onClick={() => window.location.reload()}
          >
            Retry
          </button>
        </div>
      )}


      {!loading && !error && images.length > 0 && (
        <>
          <div
            className="pe-carousel-wrapper"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
          >
            <div className="pe-image-grid">
              {getCurrentSlideImages().map((image, index) => (
                <div
                  key={image.id}
                  className={`pe-grid-item ${getGridItemClass(index)}`}
                >
                  <div className="pe-image-wrapper">
                    <img
                      src={image.url}
                      alt={image.alt}
                      className="grid-image"
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                    <div className="download-overlay">
                      <button
                        className="download-btn"
                        onClick={() => downloadImage(image.url, image.id)}
                        title="Download Image"
                      >
                         <img 
                          src={downloadImg} 
                          alt="Download" 
                          width="18" 
                          height="18"
                          style={{ display: 'block' }}
                        />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>


          {/* <div className="slide-indicators">
            {Array.from({ length: totalSlides }).map((_, index) => (
              <button
                key={index}
                className={`indicator ${currentSlide === index ? 'active' : ''}`}
                onClick={() => setCurrentSlide(index)}
              />
            ))}
          </div> */}
        </>
      )}
        <div className="carousel-header">
        {/* <h2>USS AIC 2025 Event Gallery {images.length > 0 && `(${images.length} images)`}</h2> */}
        <div className="carousel-controls-new">
          <button
            className="control-btn"
            onClick={prevSlide}
            disabled={totalSlides <= 1 || loading}
          >
            <ChevronLeft size={20} />
          </button>
          <span className="slide-counter">
            {loading ? 'Loading...' : `${currentSlide + 1} / ${totalSlides}`}
          </span>
          <button
            className="control-btn"
            onClick={nextSlide}
            disabled={totalSlides <= 1 || loading}
          >
            <ChevronRight size={20} />
          </button>
          {/* <button
            className="pause-btn"
            onClick={() => setIsPaused(!isPaused)}
            disabled={loading}
          >
            {isPaused ? 'Resume' : 'Pause'}
          </button> */}
        </div>
      </div>
      </Container>
    </div>
  );
};


export default GridCarousel;